import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';
import { Moment } from 'moment';

export class CustomValidators {

    static minDate(date: Date | Moment): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} | null =>
            control.value < date ? {minDate: {value: true}} : null;
    }

    static maxDate(max_date: Date | Moment): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} | null =>
            {
                const selected_date = moment(control.value).startOf('month');
                const moment_max_date = moment(max_date).startOf('month');
                if(selected_date.isAfter(moment_max_date)){
                    return { maxDate: { value: true } };
                }
                return null;
            };
    }

    static diffDateToNow(beforeOrAfter: 'before' | 'after', years: number = 0, month: number = 0, days: number = 0): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} | null => {
            if (control.value === null) { return null; }

            const date = moment(control.value).startOf('month');
            let now = moment().startOf('month');
            let has_failed = false;

            if (beforeOrAfter.includes('before')) {
                now = now.subtract(years, 'years').subtract(month, 'month').subtract(days, 'day');
                has_failed = date.isBefore(now);
            } else {
                now = now.add(years, 'years').add(month, 'month').add(days, 'day');
                has_failed = date.isAfter(now);
            }

            if (has_failed) { return {diffDateToNow: {value: true}}; }

            return null;
        };
    }

    static minimumAge(age: number): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} | null => {
            if (control.value === null) { return null; }

            const date = moment(control.value);
            const now = moment();
            const yearsDiff = now.diff(date, 'years');
           if (yearsDiff < age ) {
                return {minimumAge: {value: true}}; 
            }

            return null;
        };
    }
    
    static checkDniNie(control: AbstractControl): ValidationErrors | null {
        const value = (control.value || '').toUpperCase().trim();

        if (!value) return null;

        const niePrefixMap: Record<string, string> = { X: '0', Y: '1', Z: '2' };
        const prefix = value.charAt(0);
        let numberPart = '';

        if (/^[XYZ]/.test(prefix)) {
        numberPart = value.replace(/^[XYZ]/, niePrefixMap[prefix]);
        } else if (/^\d/.test(prefix)) {
        numberPart = value;
        } else {
        return { invalidDniNie: true };
        }

        const dniRegex = /^(\d{8})([A-Z])$/;
        const match = numberPart.match(dniRegex);
        if (!match) return { invalidDniNie: true };

        const num = parseInt(match[1], 10);
        const letter = match[2];
        const validLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
        const expectedLetter = validLetters[num % 23];

        return letter === expectedLetter ? null : { invalidDniNie: true };
    }

    static checkPostalCode(): ValidatorFn {

        //Comprueba que 1000 < codigopostal_del_control <52999
        return (control: AbstractControl): {[key: string]: any} | null => {
            const valueToString = new String(control.value)
            if (control.value === null){
                return {checkDNI: {value: true}} 
            } 
            const CPRExp = /^(?:0?[1-9]|[1-4]\d|5[0-2])\d{3}$/i;         
            if(control.value){
                const str = control.value.toString();
                if (!CPRExp.test(str))  {
                    return {checkPostalCode: {value: true}}
                }          
            }
            return null;
        }
    }

    static checkAccountNumber(): ValidatorFn {
        return (control: AbstractControl): {[key: string]: any} | null => {
            let IBAN = new String(control.value)
             //Se pasa a Mayusculas
            IBAN = IBAN.toUpperCase();
                //Se quita los blancos de principio y final.
            IBAN = IBAN.trim();
            IBAN = IBAN.replace(/\s/g, ""); //Y se quita los espacios en blanco dentro de la cadena
        
            var letra1,letra2,num1,num2;
            var isbanaux;
            //var numeroSustitucion;
            //La longitud debe ser siempre de 24 caracteres
            if (IBAN.length != 24) {
                return {checkAccountNumber: {value: true}};                
            }        
            // Se coge las primeras dos letras y se pasan a números
            letra1 = IBAN.substring(0, 1);
            letra2 = IBAN.substring(1, 2);
            num1 = this.getnumIBAN(letra1);
            num2 = this.getnumIBAN(letra2);
            //Se sustituye las letras por números.
            isbanaux = String(num1) + String(num2) + IBAN.substring(2);
            // Se mueve los 6 primeros caracteres al final de la cadena.
            isbanaux = isbanaux.substring(6) + isbanaux.substring(0,6);
        
            //Se calcula el resto, llamando a la función modulo97, definida más abajo
            let resto = this.modulo97(isbanaux);
            if (resto == '1'){
                return null;
            }else{
                return {checkAccountNumber: {value: true}};
            }                
    
        }
    }

    static checkCreditCard(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const raw = (control.value || '').toString();
            const value = raw.replace(/\D+/g, '');

            if (!value) return null;

            const creditCard_regex =
            '^(?:4[0-9]{12}(?:[0-9]{3})?' +        // Visa
            '|5[1-5][0-9]{14}' +                   // MasterCard (clásico)
            '|2[2-7][0-9]{14}' +                   // MasterCard (rango nuevo)
            '|3[47][0-9]{13}' +                    // Amex
            '|3(?:0[0-5]|[68][0-9])[0-9]{11}' +    // Diners Club
            '|6(?:011|5[0-9]{2})[0-9]{12}' +       // Discover
            '|35[0-9]{14})$';                      // JCB

            const regex = new RegExp(creditCard_regex);

            return regex.test(value) ? null : { checkCreditCard: { value: true } };
        };
    }

    static modulo97(iban: string):String {
        let parts = Math.ceil(iban.length/7);
        let remainer = "";
    
        for (var i = 1; i <= parts; i++) {
            remainer = String(parseFloat(remainer+iban.substr((i-1)*7, 7))%97);
        }
    
        return remainer;
    }
    
    static getnumIBAN(letra: string) {
        let ls_letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        return ls_letras.search(letra) + 10;
    }
}
